// create a new array with unique values
export function getUniqueArrayValues<T = unknown>(array: T[]): T[] {
  return [...new Set(array)];
}
